<template>
	<div id="app" v-cloak>
		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'App',
	data(){
		return {
		}
	}
}
</script>

<style>
*,*:after,*::before{
	box-sizing:border-box;
	-ms-box-sizing:border-box;
	-moz-box-sizing:border-box;
	-webkit-box-sizing:border-box;
}
*{
	text-decoration:none;
	list-style:none;
	margin:0;
	padding:0;
	border:none;
	line-height: 1;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	font-size:14px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
[v-cloak]{
	display: none;
}
.el-breadcrumb{
	margin-bottom: 20px;
}
.el-page-header{
	margin-bottom: 20px;
}
.btns{
	margin-bottom: 20px;
}
.l10{
	margin-left: 10px;
}
.bnone{
	margin-bottom: 0;
}
.el-page-header__left{
	display: flex;
	align-items: center;
}
.el-pagination{
	padding:0!important;
	margin-top: 20px;
}
.el-popconfirm__action{
	margin-top: 10px!important;
}

.acea-row {
	display: -webkit-box;
	display: -moz-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-lines: multiple;
	-moz-box-lines: multiple;
	-o-box-lines: multiple;
	-webkit-flex-wrap: wrap;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	/* 辅助类 */
}

.acea-row.row-middle {
	-webkit-box-align: center;
	-moz-box-align: center;
	-o-box-align: center;
	-ms-flex-align: center;
	-webkit-align-items: center;
	align-items: center;
}

.acea-row.row-top {
	-webkit-box-align: start;
	-moz-box-align: start;
	-o-box-align: start;
	-ms-flex-align: start;
	-webkit-align-items: flex-start;
	align-items: flex-start;
}

.acea-row.row-bottom {
	-webkit-box-align: end;
	-moz-box-align: end;
	-o-box-align: end;
	-ms-flex-align: end;
	-webkit-align-items: flex-end;
	align-items: flex-end;
}

.acea-row.row-center {
	-webkit-box-pack: center;
	-moz-box-pack: center;
	-o-box-pack: center;
	-ms-flex-pack: center;
	-webkit-justify-content: center;
	justify-content: center;
}

.acea-row.row-right {
	-webkit-box-pack: end;
	-moz-box-pack: end;
	-o-box-pack: end;
	-ms-flex-pack: end;
	-webkit-justify-content: flex-end;
	justify-content: flex-end;
}

.acea-row.row-left {
	-webkit-box-pack: start;
	-moz-box-pack: start;
	-o-box-pack: start;
	-ms-flex-pack: start;
	-webkit-justify-content: flex-start;
	justify-content: flex-start;
}

.acea-row.row-between {
	-webkit-box-pack: justify;
	-moz-box-pack: justify;
	-o-box-pack: justify;
	-ms-flex-pack: justify;
	-webkit-justify-content: space-between;
	justify-content: space-between;
}

.acea-row.row-around {
	justify-content: space-around;
	-webkit-justify-content: space-around;
}

.acea-row.row-column-around {
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
	justify-content: space-around;
	-webkit-justify-content: space-around;
}

.acea-row.row-column {
	-webkit-box-orient: vertical;
	-moz-box-orient: vertical;
	-o-box-orient: vertical;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
}

.acea-row.row-column-between {
	-webkit-box-orient: vertical;
	-moz-box-orient: vertical;
	-o-box-orient: vertical;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
	-webkit-box-pack: justify;
	-moz-box-pack: justify;
	-o-box-pack: justify;
	-ms-flex-pack: justify;
	-webkit-justify-content: space-between;
	justify-content: space-between;
}

/* 上下左右垂直居中 */
.acea-row.row-center-wrapper {
	-webkit-box-align: center;
	-moz-box-align: center;
	-o-box-align: center;
	-ms-flex-align: center;
	-webkit-align-items: center;
	align-items: center;
	-webkit-box-pack: center;
	-moz-box-pack: center;
	-o-box-pack: center;
	-ms-flex-pack: center;
	-webkit-justify-content: center;
	justify-content: center;
}

/* 上下两边居中对齐 */
.acea-row.row-between-wrapper {
	-webkit-box-align: center;
	-moz-box-align: center;
	-o-box-align: center;
	-ms-flex-align: center;
	-webkit-align-items: center;
	align-items: center;
	-webkit-box-pack: justify;
	-moz-box-pack: justify;
	-o-box-pack: justify;
	-ms-flex-pack: justify;
	-webkit-justify-content: space-between;
	justify-content: space-between;
}

/*距离样式*/
.mr {
	margin-right: 15px;
}

.mr10 {
	margin-right: 10px;
}

.ml20 {
	margin-left: 20px;
}

.ml10 {
	margin-left: 10px;
}

.ml40 {
	margin-left: 40px !important;
}
.ml95 {
	margin-left: 95px !important;
}

.pt5 {
	padding: 5px 0 !important;
	box-sizing: border-box;
}

.mr50 {
	margin-right: 50px;
}

.mr20 {
	margin-right: 20px !important;
}

.mr15 {
	margin-right: 15px !important;
}
.mr5 {
	margin-right: 5px !important;
}

.mb20 {
	margin-bottom: 20px !important;
}
.mb5 {
	margin-bottom: 5px !important;
}
.mb15 {
	margin-bottom: 15px !important;
}

.mb30 {
	margin-bottom: 30px !important;
}

.mt30 {
	margin-top: 30px;
}

.mt25 {
	margin-top: 25px;
}

.mt20 {
	margin-top: 20px;
}

.mt50 {
	margin-top: 50px;
}

.mt10{
	margin-top: 10px;
}
.mb10 {
	margin-bottom: 10px !important;
}
.mb5 {
	margin-bottom: 5px !important;
}
</style>
